// client/src/components/marketer/MarketerTabbar.js
// 마이비즈 모바일 하단 탭바 (≤1024px에서 표시 — mb-ui.css, 사이드바 숨김 구간과 통일)
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ICONS = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /></svg>
  ),
  project: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="3" /><path d="M8 3v4M16 3v4M3 10h18" /></svg>
  ),
  create: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M12 5v14M5 12h14" /></svg>
  ),
  point: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
  ),
  my: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" /></svg>
  ),
};

// 시안 확정(2026-07-27): 홈 / 프로젝트 / 등록(중앙) / 포인트 / 내 정보
// 내 정보 탭은 my(계정·비밀번호)와 inquiry(고객센터)를 함께 담당한다.
const TABS = [
  { key: 'home', label: '홈', tab: 'home', sub: 'home', isActive: (t, s) => s === 'home' || !s },
  { key: 'project', label: '프로젝트', tab: 'project', sub: 'prjOn', isActive: (t, s) => t === 'project' && s !== 'prjCreate' },
  { key: 'create', label: '등록', tab: 'project', sub: 'prjCreate', center: true, isActive: (t, s) => s === 'prjCreate' },
  { key: 'point', label: '포인트', tab: 'point', sub: 'pointCharge', isActive: (t) => t === 'point' },
  { key: 'my', label: '내 정보', tab: 'my', sub: 'myInfo', isActive: (t) => t === 'my' || t === 'inquiry' },
];

function MarketerTabbar() {
  const nav = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('tab');
  const sub = params.get('sub');

  return (
    <nav className="mb-tabbar" aria-label="마이비즈 주요 메뉴">
      {TABS.map((t) => {
        const active = t.isActive(tab, sub);
        if (t.center) {
          return (
            <button
              key={t.key}
              type="button"
              className={`mb-tabbar__item mb-tabbar__item--new ${active ? 'is-active' : ''}`}
              onClick={() => nav(`/marketer/mybiz?tab=${t.tab}&sub=${t.sub}`)}
            >
              <span>{ICONS[t.key]}</span>
              <em>{t.label}</em>
            </button>
          );
        }
        return (
          <button
            key={t.key}
            type="button"
            className={`mb-tabbar__item ${active ? 'is-active' : ''}`}
            onClick={() => nav(`/marketer/mybiz?tab=${t.tab}&sub=${t.sub}`)}
          >
            {ICONS[t.key]}
            {t.label}
          </button>
        );
      })}
    </nav>
  );
}

export default MarketerTabbar;
